import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`if (PostHog.isFeatureEnabled("flag-key") ) {
    // do something
}
`}</code></pre>
    <h3 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`if (PostHog.getFeatureFlag("flag-key")  == "variant-key") { // replace 'variant-key' with the key of your variant
    // do something
}
`}</code></pre>
    <h3 {...{
      "id": "reloading-feature-flags"
    }}>{`Reloading feature flags`}</h3>
    <p>{`Feature flag values are cached. If something has changed with your user and you'd like to refetch their flag values, call the `}<inlineCode parentName="p">{`reloadFeatureFlags`}</inlineCode>{` method.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`PostHog.reloadFeatureFlags()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      